import React, { useEffect, useRef, useState } from 'react'

import { capitalize } from 'lodash';
import { useParams } from 'react-router-dom';
import Link from '../Link';
import Editor from "../Editor";

import style from './style.module.css';

const Item = ({ title = "Accordion", description, className = "", refresh = false, url = false }) => {
    const [isActive, setIsActive] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0);

    const { accordion = null } = useParams()
    const ref = useRef(false)

    const handleToggle = () => {
        setIsActive((prev) => !prev);
        ref.current = true;
    }

    useEffect(() => {
        if (accordion !== null && capitalize(accordion) === title) {
            setIsActive(true)
            ref.current = true;
        }
    }, [accordion, title])

    return (
        <div className={`${style.container}${isActive === true ? " " + style.active : ""}${className !== "" ? ` ${className}` : ""}`}>
            <div className={style.buttons}>
                <div className={style.title}>
                    <div>{title}</div>
                    <div className={style.icon}>
                        {
                            isActive === true && refresh !== false && (
                                <Link className={`${style.refreshIcon}`} onClick={() => setRefreshKey((prev) => prev + 1)}><i className="fa-solid fa-arrows-rotate"></i></Link>
                            )
                        }
                        <div className={style.arrow}>
                            <span className={style.plus}></span>
                        </div>
                    </div>
                </div>
            </div>
            <Link to={url && !ref.current ? url : ""} className={style.fullBlock} onClick={handleToggle}></Link>
            {
                ref.current === true && (
                    <div className={style.content}>
                        <div className={style.child} key={`accordion_item_${refreshKey}_${title}`}>
                            <Editor text={description} />
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Item